import cn from 'classnames';

import ContentWithSidebar from 'components/content-with-sidebar/ContentWithSidebar';
import EmptyList from 'components/empty-list/EmptyList';
import FilterLayout from 'components/filter-layout/FilterLayout';
import Form from 'components/form/Form';
import Link from 'components/link/Link';
import TabList from 'components/tabs/TabList';
import TabListItem from 'components/tabs/TabListItem';
import Spinner from 'components/spinner/Spinner';
import useFetchFilteredResults from 'js/hooks/use-fetch-filtered-results';
import EventListItem from 'components/event-list-item/EventListItem';

import { IEventListPage } from 'source/NFR.types';

type EventListFilterState = Pick<IEventListPage, 'emptyList' | 'filterLayout' | 'events'>;

const EventListPage: React.FC<IEventListPage> = ({
  emptyList,
  events = [],
  filterLayout,
  form,
  title,
  topFilter,
  fetchFilteredResultsEndpoint
}) => {
  const [isLoading, { emptyList: emptyListState, filterLayout: filterLayoutState, events: eventsState }, fetchResults] =
    useFetchFilteredResults<EventListFilterState>(
      { emptyList, filterLayout, events },
      fetchFilteredResultsEndpoint,
      form.endpoint,
      topFilter.timeframe ? { ...topFilter.timeframe, value: String(topFilter.timeframe.value) } : undefined
    );

  return (
    <Form className="event-list-page" showSubmitButton={false} {...form}>
      <ContentWithSidebar>
        {title && (
          <h1
            className={cn([
              'event-list-page__title',
              {
                'event-list-page--title--no-tabs': !!topFilter && !topFilter.options
              }
            ])}
          >
            {title}
          </h1>
        )}
      </ContentWithSidebar>
      <FilterLayout
        {...filterLayoutState}
        fetchFilteredResults={fetchResults}
        includeBottomBorder={false}
        topContent={
          topFilter &&
          topFilter.options && (
            <TabList className="event-list-page--tab-list">
              {topFilter.options?.map(({ isCurrent, link }, index) => (
                <TabListItem
                  key={link.url}
                  isCurrent={isCurrent}
                  length={topFilter.options.length}
                  index={index}
                  currentIndex={topFilter.options.findIndex(({ isCurrent }) => isCurrent)}
                >
                  <Link theme={isCurrent ? 'black' : undefined} {...link} />
                </TabListItem>
              ))}
            </TabList>
          )
        }
        isLoading={isLoading}
      >
        <div className="event-list-page--events">
          {eventsState && eventsState.length > 0 ? (
            eventsState?.map((event, idx: number) => (
              <EventListItem key={event.eventCard && event.eventCard.title + idx} {...event} />
            ))
          ) : (
            <EmptyList {...emptyListState} />
          )}
          <Spinner isActive={isLoading} />
        </div>
      </FilterLayout>
    </Form>
  );
};

EventListPage.displayName = 'EventListPage';

export default EventListPage;
